<template>

    <div id="lock-months">
      <div class="content-wrapper">
        <div class="page-heading">
            <h1 class="page-title">{{$t('message.taskHistory')}}</h1>
            <div class="page-content fade-in-up">
               <div class="row">
                    <div class="col-md-12">
                          <div class="ibox">
                                <div class="ibox-body"> 
                                   <div class="tab-pane fade active show">
                                     <div class="go-back" @click="goBack">
                                          <i style="padding: 3px" class="fa fa-arrow-left"></i>
                                          <span class="backToButton" style="padding: 3px; ">{{$t('message.backToProjectPage')}}</span>
                          
                                      </div>

                                    <div class="row">

                                        <table class="table table-striped" v-if="tasks.length">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th scope="col">{{$t('message.companyName')}}</th>
                                                        <th scope="col">{{$t('message.contractNumber')}}</th>
                                                        <th scope="col">{{$t('message.name')}}</th>
                                                        <th scope="col">{{$t('message.details')}}</th>
                                                        <th scope="col">{{$t('message.created')}}</th>
                                                        <th scope="col">{{$t('message.issuedBy')}}</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        <tr v-for="(task, index) in tasks" :key="index">
                                                          <td></td>
                                                        <td style="vertical-align:middle">{{task.company_name}}</td>
                                                        <td style="vertical-align:middle">{{task.contract_number}}</td>
                                                        <td style="vertical-align:middle">{{task.name}}</td>
                                                            
                                                        <td style="vertical-align:middle;">
                                                            <div v-for='(detail, index) in task.details' :key="index">
                                                                      <span style="margin-right: 10px"><b>{{removeDayFromDate(detail.value)}}:</b></span><span> CHF {{format(Number(detail.amount))}}</span> 
                                                            </div>
                                                        </td>
                                                        <td style="vertical-align: middle">{{task.created}}</td>
                                                        <td style="vertical-align: middle"><b>{{task.issued_by}}</b></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                          </table>

                                    </div>

                                   </div> 
                                </div> 
                          </div>  
                    </div>
                    
                </div>
                  
            </div>
        </div>  
      </div> 
    </div>
</template>

<script>

export default {
    name: 'TaskHistory',
    components: {
      
    },
    data(){
      return {
         tasks: []
      }
    },
    created(){
         console.log(this.$route.params['id'])
         this.getList(this.apiPrefix, this.projectApiUrl + `get-tasks-per-project/?project_id=${this.$route.params['id']}&done=True`)
          .then(resp => {

            this.tasks = resp.data.map(row => ({
              // removes slashes from received string and formats message
              name: ( (name) => {
                const strippedName = name.replace(/_/g, "")
                return this.$t(`message.${strippedName}`)
              })(row.name),
              created: this.$moment(row.created).format("YYYY-MM-DD"),
              contract_number: row.sheet.contract_number,
              company_name: JSON.parse(row.additional_data).company_name,
              details: JSON.parse(row.additional_data).additional_budgets,
              issued_by: this.$t(`message.${row.issued_by}`)
            }))
          })
          .catch(err => {
            console.log(err)
          })
      
    },
    methods: { 

      goBack () {
        this.$router.push({name: 'EditProject', params: {id: this.$route.params["id"]}})
      },
   
    },
  }
  
</script>

<style scoped>
  


</style>
